<template>
  <div class="emailSet">
    <Card class="card">
      <Form
        ref="emailForm"
        :model="emailData"
        :rules="emailRule"
        :label-width="250"
      >
        <FormItem label="邮件服务："> SMTP服务 </FormItem>
        <FormItem label="邮件服务器是否加密连接（SSL）：" prop="isSsl">
          <RadioGroup v-model="emailData.isSsl">
            <Radio label="1">开启</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="邮件发送：" prop="isEmail">
          <RadioGroup v-model="emailData.isEmail">
            <Radio label="1">开启</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="SMTP服务器：" prop="smtpServer">
          <Input
            class="input"
            v-model="emailData.smtpServer"
            v-filter-space
            placeholder="请输入SMTP服务器"
          ></Input>
        </FormItem>
        <FormItem label="SMTP端口：" prop="smtpPort">
          <Input
            class="input"
            v-model="emailData.smtpPort"
            v-filter-space
            placeholder="请输入SMTP端口"
          ></Input>
        </FormItem>
        <!-- <FormItem label="SMTP用户身份验证：" prop="isSmtpAuth">
          <RadioGroup v-model="emailData.isSmtpAuth">
            <Radio label="1">开启</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </FormItem> -->
        <FormItem label="验证用户名：" prop="authUserName">
          <Input
            class="input"
            v-model="emailData.authUserName"
            v-filter-space
            placeholder="请输入用户名"
          ></Input>
        </FormItem>
        <FormItem label="验证密码：" prop="authPassword">
          <Input
            class="input"
            type="password"
            v-model="emailData.authPassword"
            v-filter-space
            placeholder="请输入密码"
          ></Input>
        </FormItem>
        <FormItem label="邮箱测试" prop="email">
          <Input
            class="inputMsg"
            v-model="emailData.email"
            v-filter-space
            placeholder="请输入邮箱进行测试"
          ></Input>
          <Button type="primary" class="msgTest" @click="msgTest"
            >邮箱测试</Button
          >
        </FormItem>
        <FormItem>
          <Button type="primary" class="saveBtn" @click="saveSet">保存</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import { emailSave, emailTest, getEmail } from "@/api/msg";

export default {
  name: "EmailSet",
  data() {
    return {
      emailData: {
        isSsl: "0", //邮件服务器是否加密连接（SSL）
        isEmail: "0", //是否开启邮件发送
        smtpServer: "",
        smtpPort: "",
        isSmtpAuth: "0", //是否开启身份验证
        authUserName: "",
        authPassword: "",
        email: "",
      },
      emailRule: {
        isSsl: [
          {
            required: true,
            message: "请选择加密连接",
            trigger: "blur",
          },
        ],
        isEmail: [
          {
            required: true,
            message: "请选择邮件发送",
            trigger: "blur",
          },
        ],
        smtpServer: [
          {
            required: true,
            message: "请输入SMTP服务器",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "最多可以包含32个字符",
            trigger: "blur",
          },
        ],
        smtpPort: [
          {
            required: true,
            validator(rule, value, callback) {
              let reg = /^\d+$/;
              if (!value) {
                callback(new Error("请输入SMTP端口"));
              }
              if (!reg.test(value) || value > 65535 || value < 1) {
                callback(new Error("请输入1-65535之间的整数"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        isSmtpAuth: [
          {
            required: true,
            message: "SMTP用户身份验证：",
            trigger: "blur",
          },
        ],
        authUserName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入用户名",
          },
          {
            trigger: "blur",
            min: 5,
            max: 32,
            message: "字符在5-32位之间",
          },
        ],
        authPassword: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            trigger: "blur",
            min: 6,
            max: 32,
            message: "字符在6-32位之间",
          },
        ],
        email: [
          {
            pattern:
              /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
            trigger: "blur",
            message: "邮箱格式不正确",
          },
        ],
      },
    };
  },
  created() {
    this.getEmail();
  },
  methods: {
    link(path) {
      //  this.$Message.success("撤回成功");
      this.$router.push({ path: path });
    },
    // 保存邮箱配置
    saveSet() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          let query = {
            isSsl: this.emailData.isSsl,
            isEmail: this.emailData.isEmail,
            smtpServer: this.emailData.smtpServer,
            smtpPort: this.emailData.smtpPort,
            isSmtpAuth: this.emailData.isSmtpAuth,
            authUserName: this.emailData.authUserName,
            authPassword: this.emailData.authPassword,
            email: this.emailData.email,
          };
          console.log("添加的信息为:", query);
          emailSave(query)
            .then((res) => {
              this.$Message.success("保存成功");
              console.log("res", res);
            })
            .catch((err) => {
              console.log(err, "请求接口失败");
            });
        } else {
          this.loading = false;
          console.log("请在正确填写表单信息");
        }
      });
    },
    // 短信测试
    msgTest() {
      if (!this.emailData.email) {
        this.$Message.error("请输入测试邮箱");
        return;
      }
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          let query = {
            isSsl: this.emailData.isSsl,
            isEmail: this.emailData.isEmail,
            smtpServer: this.emailData.smtpServer,
            smtpPort: this.emailData.smtpPort,
            isSmtpAuth: this.emailData.isSmtpAuth,
            authUserName: this.emailData.authUserName,
            authPassword: this.emailData.authPassword,
            email: this.emailData.email,
          };
          console.log("添加的信息为:", query);
          emailTest(this.emailData.email, query)
            .then((res) => {
              this.$Message.success("测试短信已发送，请注意查收");
              console.log("res", res);
            })
            .catch((err) => {
              console.log(err, "请求接口失败");
            });
        } else {
          this.loading = false;
          console.log("请在正确填写表单信息");
        }
      });
    },
    getEmail() {
      getEmail().then((res) => {
        this.emailData = Object.assign({}, this.emailData, res.data.data);
      });
    },
  },
};
</script>

<style lang="scss">
.emailSet {
  width: 100%;
  .card {
    width: 100%;
    min-height: calc(100vh - 150px);
    font-size: 14px;
    color: #2f4061;
    padding-top: 10px;
    .input {
      width: 410px;
    }
    .inputMsg {
      width: 280px;
    }
    .saveBtn,
    .msgTest {
      width: 104px;
      height: 36px;
      background: #3c8aff;
      border-radius: 18px;
    }
    .msgTest {
      margin-left: 25px;
    }
  }
}
</style>